<div class="row" *ngIf="!spinner">
    <div class="col-lg-2 mt-2" style="border-right: 1px solid #d8d8d8">
        <div *ngIf="detailsLine$ | async as detailsLine">
            <fieldset>
                <legend>
                    <strong>Soumission</strong>
                </legend>
                <div class="d-flex flex-column gap-2">
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Matricule&nbsp;:&nbsp;</strong
                            >{{ detailsLine?.demandeur_matricule ?? '' }}</span
                        >
                    </div>
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Nom complet&nbsp;:&nbsp;</strong
                            >{{ detailsLine?.demandeur_nom ?? '' }}
                            {{ detailsLine?.demandeur_prenoms ?? '' }}</span
                        >
                    </div>
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Contact&nbsp;:&nbsp;</strong
                            >{{ detailsLine?.demandeur_contacts ?? '' }}</span
                        >
                    </div>
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Email&nbsp;:&nbsp;</strong
                            >{{ detailsLine?.demandeur_email ?? '' }}</span
                        >
                    </div>
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Date&nbsp;:&nbsp;</strong
                            >{{ detailsLine?.created_at ?? '' }}</span
                        >
                    </div>
                </div>
            </fieldset>
        </div>

        <div *ngIf="detailsLine$ | async as detailsLine">
            <fieldset>
                <legend>
                    <strong>Réservation</strong>
                </legend>
                <div class="d-flex flex-column gap-2">
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Matricule&nbsp;:&nbsp;</strong
                            >{{
                                detailsLine?.intervenant?.matricule ?? ''
                            }}</span
                        >
                    </div>
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Nom Complet&nbsp;:&nbsp;</strong
                            >{{ detailsLine?.intervenant?.nom ?? '' }}
                            {{ detailsLine?.intervenant?.prenoms ?? '' }}</span
                        >
                    </div>
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Contact&nbsp;:&nbsp;</strong
                            >{{
                                detailsLine?.intervenant?.contacts ?? ''
                            }}</span
                        >
                    </div>
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Email&nbsp;:&nbsp;</strong
                            >{{ detailsLine?.intervenant?.email ?? '' }}</span
                        >
                    </div>
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Date&nbsp;:&nbsp;</strong
                            >{{
                                detailsLine?.rapport?.date_traitement ??
                                    detailsLine?.rapport?.date_acquittement
                            }}</span
                        >
                    </div>
                </div>
            </fieldset>
        </div>

        <div>
            <fieldset *ngIf="detailsLine$ | async as detailsLine">
                <legend>
                    <strong>Activation</strong>
                </legend>
                <div class="d-flex flex-column gap-2">
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Matricule&nbsp;:&nbsp;</strong
                            >{{
                                detailsLine?.intervenant?.matricule ?? ''
                            }}</span
                        >
                    </div>
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Nom Complet&nbsp;:&nbsp;</strong
                            >{{ detailsLine?.intervenant?.nom ?? '' }}
                            {{ detailsLine?.intervenant?.prenoms ?? '' }}</span
                        >
                    </div>
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Contact&nbsp;:&nbsp;</strong
                            >{{
                                detailsLine?.intervenant?.contacts ?? ''
                            }}</span
                        >
                    </div>
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Email&nbsp;:&nbsp;</strong
                            >{{ detailsLine?.intervenant?.email ?? '' }}</span
                        >
                    </div>
                    <div>
                        <span class="mb-0 fs__13"
                            ><strong>Date&nbsp;:&nbsp;</strong
                            >{{
                                detailsLine?.rapport?.date_traitement ??
                                    detailsLine?.rapport?.date_acquittement
                            }}</span
                        >
                    </div>
                </div>
            </fieldset>
        </div>
    </div>

    <div *ngIf="detailsLine$ | async as detailsLine" class="col-lg-10 mt-2">
        <div class="col-lg-12">
            <div
                role="alert"
                style="display: flex; justify-content: space-between"
                [ngClass]="OnGetRapportCodeStyle(detailsLine?.rapport?.code)"
            >
                <div>
                    <strong class="wrapper-header"
                        >Réservation :
                        {{ detailsLine?.rapport.statut_acquittement ?? '' }}
                        [{{
                            detailsLine?.rapport?.date_acquittement ??
                                '-- : --'
                        }}]
                    </strong>
                </div>
                <div>
                    <strong class="wrapper-header"
                        >Activation :
                        {{ detailsLine?.rapport.statut_traitement ?? '' }}
                        [{{
                            detailsLine?.rapport?.date_traitement ?? '-- : --'
                        }}]
                    </strong>
                </div>
                <div>
                    <strong class="wrapper-header"
                        >Clôture :
                        {{
                            (detailsLine$ | async)?.rapport.statut_cloture ?? ''
                        }}
                        [{{
                            (detailsLine$ | async)?.rapport?.date_cloture ??
                                '-- : --'
                        }}]
                    </strong>
                </div>
            </div>
            <div class="d-flex justify-content-between">
                <h4 class="wrapper-header" style="width: fit-content">
                    <strong>{{
                        getTitleForm((detailsLine$ | async)?.operation)
                    }}</strong>
                </h4>
                <div
                    class="wrapper-header"
                    style="display: flex; justify-content: end; font-size: 20px"
                >
                    Date mise à jour :&nbsp;<b
                        ><span>{{
                            (detailsLine$ | async)?.updated_at ?? 'N/A'
                        }}</span></b
                    >
                </div>
            </div>

            <hr />

            <div
                *ngIf="
                    (detailsLine$ | async)?.operation ===
                    typeOperation.ACTIVATION
                "
            >
                <div>
                    <div>
                        <div class="row">
                            <fieldset>
                                <legend>
                                    <b>Informations SIM</b>
                                </legend>
                                <div class="row">
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>MSISDN</b>
                                            </label>
                                            <input
                                                type="text"
                                                [value]="detailsLine?.msisdn"
                                                disabled
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>IMSI</b>
                                            </label>
                                            <input
                                                type="text"
                                                [value]="detailsLine?.imsi"
                                                disabled
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>ICCID</b>
                                            </label>
                                            <input
                                                type="text"
                                                [value]="detailsLine?.iccid"
                                                disabled
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>APN</b>
                                            </label>
                                            <input
                                                type="text"
                                                [value]="detailsLine?.apn"
                                                disabled
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                    <div class="col-md">
                                        <div class="form-group">
                                            <label>
                                                <b>Adresse IP</b>
                                            </label>
                                            <input
                                                type="text"
                                                [value]="
                                                    detailsLine?.adresse_ip
                                                "
                                                disabled
                                                pInputText
                                            />
                                        </div>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                    <fieldset>
                        <legend>
                            <b>Informations d'utilisation</b>
                        </legend>
                        <div class="row pb-2">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>
                                        <b>Formule d'abonnement</b>
                                    </label>
                                    <input
                                        type="text"
                                        [value]="detailsLine?.formule"
                                        disabled
                                        pInputText
                                    />
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>
                                        <b>Usage</b>
                                    </label>
                                    <input
                                        type="text"
                                        [value]="detailsLine?.usage_nom"
                                        disabled
                                        pInputText
                                    />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <label for="commentaire"
                                    ><strong>Description</strong></label
                                >
                                <input
                                    type="text"
                                    [value]="detailsLine?.description"
                                    disabled
                                    pInputText
                                />
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="d-flex justify-content-center align-items-center" *ngIf="spinner">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
</div>
